/**
 * العودة إلى الصفحة المطلوبة بعد تسجيل الدخول — لروابط أوامر العمل الواردة في البريد.
 * يُقبل المسار الداخلي فقط (لا روابط خارجية)، والصلاحيات تُطبَّق بعد الدخول كالمعتاد.
 */
const KEY = "asf.returnTo";
const ALLOWED = /^\/work-order\/\d+(\?[\w=&%-]*)?$/;

export function rememberReturnTo(path) {
  if (!ALLOWED.test(path || "")) return;
  try { sessionStorage.setItem(KEY, path); } catch { /* المتصفح يمنع التخزين: الدخول يذهب للصفحة الافتراضية */ }
}

export function takeReturnTo() {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return ALLOWED.test(path || "") ? path : null;
  } catch {
    return null;
  }
}
